<div class="language-button-wrap">
	<ion-icon class="language-button-icon" name="globe-outline" aria-hidden="true"></ion-icon>
	<ion-select class="language-button-select" aria-label="Language" interface="popover" [value]="lang"
	            (ionChange)="switchLang($event)">
		@for (lg of languageList; track lg.shortCode) {
			<ion-select-option [value]="lg.shortCode">{{ getLanguageLabel(lg.shortCode) }}</ion-select-option>
		}
	</ion-select>
</div>
